var roadTransport = [
  {
    id: 1,
    name:"普通货运"
  },
  {
    id: 2,
    name:"专用货运"
  },
  {
    id: 3,
    name:"大型物件运输"
  }]

export default roadTransport